import {
    SMS_LOOKUP_FILTER
} from "../actions";

export const smsLookupFilter = (state = false, action) => {

    switch (action.type) {
      case SMS_LOOKUP_FILTER:
        return action.payload;
  
      default:
  
        return state;
  
    }
  
};